module.exports = __webpack_public_path__ + "fonts/OpenSans-SemiBold.70e6b045.woff2";